import React from 'react'
import { BonusAmountDiv, BonusDescription, BonusDiv, LockedBonusCardRootDiv } from './LockedBonusCardStyles'

import lockIcon from '../assets/challenge/lockedBonusIcon.svg'
import { RUPEE_SYMBOL } from '../Strings'
import { ChallengeProgressBar, ChallengeProgressbarDiv, ChallengeProgressBarFilled, ProgressTextDiv } from './ChallengeCard.style'
import { ExpiredStamp } from './MissionCard.styles'

function LockedBonusCard(props) {
  const { bonusToBeExpired, totalBonus, userId } = props.data

  let totalBonusAmount = isNaN(Number(totalBonus)) ? 0 : (Number(totalBonus));

  let pendingBonus = isNaN(Number(bonusToBeExpired)) ? 0 : (Number(bonusToBeExpired));

  console.log(` 
    Locked Bonus Card Component 
    bonusToBeExpired >>> ${pendingBonus}  totalBonus ${totalBonusAmount} userId ${userId}
  `)


  let progressFillingPercentage = (pendingBonus / totalBonus) * 100;
  progressFillingPercentage = isNaN(progressFillingPercentage) ? 0 : progressFillingPercentage
  progressFillingPercentage += '%'

  console.log(` 
    Locked Bonus Card Component 
    progressFillingPercentage : ${progressFillingPercentage}`
  )

  return (
    <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
      <LockedBonusCardRootDiv id='lockedRootDiv'>
        <BonusDiv id='BonusPart'>
          <div>
            <img src={lockIcon} alt='bonusImg' />
          </div>
          <BonusAmountDiv id='bonusAmtPart'>
            {RUPEE_SYMBOL}{totalBonusAmount}
            <BonusDescription>Locked Bonus</BonusDescription>
          </BonusAmountDiv>



        </BonusDiv>
        <ChallengeProgressbarDiv id='lockedProgress'
          style={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: '1rem',
            height: '1.5rem',
            justifyContent: 'space-around',
            width: '75%',
          }}>
          <ChallengeProgressBar shouldShade={false} isFromBundle={false} style={{ width: '85%' }}>
            <ChallengeProgressBarFilled shouldShade={false} fillArea={progressFillingPercentage} />
          </ChallengeProgressBar>
          <ProgressTextDiv style={{ marginLeft: '0rem' }}>
            {RUPEE_SYMBOL}{pendingBonus}/{totalBonusAmount} will expire on this withdraw
          </ProgressTextDiv>
        </ChallengeProgressbarDiv>





      </LockedBonusCardRootDiv>
      <ExpiredStamp style={{ position: 'absolute', top: '35%', left: '30%' }}>
        <span style={{ fontSize: '0.75rem', fontWeight: '700', rotate: '15 deg' }}> EXPIRES ON WITHDRAW </span>
      </ExpiredStamp>
    </div>
  )
}

export default LockedBonusCard